import '../styles/pages/setup.scss'
import Loading from "../elements/Loading";
import Header from "../elements/Header";
import InlineNotification from "../elements/InlineNotification";
import s from "../styles/pages/main.module.scss";


export default function NoSettingsPage() {

    return <>
        <Loading isLoading={false}/>
        <div className={'center-main'}>
            <div className='setup-block setup-block-padding'>
                <InlineNotification
                    type={'success'}
                    text={'Настройка приложения не требуется'}
                    hideFlag={false}
                />
            </div>
        </div>
    </>
}
